import toggleButtonGroupClasses from "@mui/material/ToggleButtonGroup/toggleButtonGroupClasses";
import toggleButtonClasses from "@mui/material/ToggleButton/toggleButtonClasses";
import { button } from "../../styles/utils/button.module";
import { typography } from "../../styles/utils/typography.module";
import { resolve } from "../../styles/utils/utils";
import { MuiIconButtonTheme } from "../IconButton/IconButton.theme";
const toggleButton = (dt, type) => {
    const cta = dt.cta.outlined.color;
    const backgroundColor = resolve(cta.background, type);
    const borderColor = resolve(cta.border, type);
    const textColor = resolve(cta.text, type);
    return {
        "&[class]": {
            gap: dt.button.gap,
            border: `${dt.button.shape.border} solid ${dt.cta.outlined.color.border.neutral.default}`,
            color: dt.cta.outlined.color.text.neutral.default,
            background: "transparent",
            ".PixelIcon": {
                backgroundColor: dt.color.onSurface.key,
            },
            "&:hover, &:is(.Pxl-demo-hover, [data-demostate=hover])": {
                position: "relative",
                zIndex: 3,
                color: type !== "neutral" && textColor.hover,
                background: backgroundColor.hover,
                ".PixelIcon[class][class]": {
                    backgroundColor: type !== "neutral" && textColor.hover,
                },
            },
            "&:focus-visible, &:is(.Pxl-demo-focus, [data-demostate=focus])": {
                position: "relative",
                zIndex: 3,
                color: type !== "neutral" && textColor.focus,
                background: backgroundColor.focus,
                boxShadow: dt.state.focus[type],
                ".PixelIcon[class][class]": {
                    backgroundColor: type !== "neutral" && textColor.focus,
                },
            },
            "&:active, &:is(.Pxl-demo-pressed, [data-demostate=pressed])": {
                position: "relative",
                zIndex: 1,
                borderColor: borderColor.pressed,
                color: textColor.pressed,
                background: backgroundColor.pressed,
                ".PixelIcon[class][class]": {
                    backgroundColor: type !== "neutral" && textColor.pressed,
                },
            },
            [`&.${toggleButtonClasses.selected}`]: {
                position: "relative",
                zIndex: 2,
                borderColor: borderColor.active,
                color: type !== "neutral" && textColor.active,
                background: backgroundColor.active,
                ".PixelIcon[class][class]": {
                    backgroundColor: type !== "neutral" && textColor.active,
                },
                [`&.${toggleButtonClasses.sizeSmall}`]: typography(dt.toggleButtonGroup.typography.active.small, dt.fontFamilies.body.fallback),
                [`&.${toggleButtonClasses.sizeMedium}`]: typography(dt.toggleButtonGroup.typography.active.medium, dt.fontFamilies.body.fallback),
                [`&.${toggleButtonClasses.sizeLarge}`]: typography(dt.toggleButtonGroup.typography.active.large, dt.fontFamilies.body.fallback),
            },
            [`&.${toggleButtonClasses.disabled}, &.${toggleButtonClasses.disabled}:disabled`]: {
                borderColor: dt.cta.outlined.color.border.primary.disabled,
                color: textColor.disabled,
                background: backgroundColor.disabled,
                boxShadow: "none",
                ".PixelIcon[class][class]": {
                    backgroundColor: textColor.disabled,
                },
            },
            "&.Pxl-ToggleButton-withText": {
                width: "unset",
                [`&.${toggleButtonClasses.sizeSmall}`]: {
                    minWidth: dt.button.small,
                    height: dt.button.small,
                },
                [`&.${toggleButtonClasses.sizeMedium}`]: {
                    minWidth: dt.button.medium,
                    height: dt.button.medium,
                },
                [`&.${toggleButtonClasses.sizeLarge}`]: {
                    minWidth: dt.button.large,
                    height: dt.button.large,
                },
            },
            [`.${toggleButtonGroupClasses.root} &`]: {
                paddingTop: 0,
                paddingRight: dt.button.padding.default,
                paddingBottom: 0,
                paddingLeft: dt.button.padding.default,
                [`&.${toggleButtonClasses.sizeSmall}`]: {
                    height: dt.toggleButtonGroup.size.small,
                },
                [`&.${toggleButtonClasses.sizeMedium}`]: {
                    height: dt.toggleButtonGroup.size.medium,
                },
                [`&.${toggleButtonClasses.sizeLarge}`]: {
                    height: dt.toggleButtonGroup.size.large,
                },
                ".PixelIcon": {
                    backgroundColor: dt.color.onSurface.variant,
                },
                border: "1px solid transparent",
                [`&.${toggleButtonClasses.disabled}, &.${toggleButtonClasses.disabled}:disabled`]: {
                    borderColor: "transparent",
                },
                [`&.${toggleButtonClasses.selected}`]: {
                    borderColor: dt.cta.outlined.color.border.neutral.active,
                    [`&.${toggleButtonClasses.disabled}, &.${toggleButtonClasses.disabled}:disabled`]: {
                        borderColor: dt.cta.outlined.color.border.primary.disabled,
                    },
                    [`&.${toggleButtonClasses.primary}`]: {
                        borderColor: dt.cta.outlined.color.border.primary.active,
                    },
                },
            },
            ".Pxl-toolbar &": {
                "&:not(.Pxl-ToggleButton-withText)": {
                    paddingTop: "unset",
                    paddingRight: "unset",
                    paddingBottom: "unset",
                    paddingLeft: "unset",
                },
                ".PixelIcon": {
                    backgroundColor: dt.color.onSurface.key,
                },
                [`&.${toggleButtonClasses.sizeSmall}`]: {
                    height: dt.button.small,
                },
                [`&.${toggleButtonClasses.sizeMedium}`]: {
                    height: dt.button.medium,
                },
                [`&.${toggleButtonClasses.sizeLarge}`]: {
                    height: dt.button.large,
                },
            },
            ".Pxl-toolbar &[class][class][class]": {
                borderColor: "transparent",
            },
        },
    };
};
export const MuiToggleButtonTheme = (dt) => {
    var _a;
    const iconButtonTheme = MuiIconButtonTheme(dt);
    let stylesOverridesRoot = {};
    if ((_a = iconButtonTheme === null || iconButtonTheme === void 0 ? void 0 : iconButtonTheme.styleOverrides) === null || _a === void 0 ? void 0 : _a.root) {
        stylesOverridesRoot = iconButtonTheme.styleOverrides.root;
    }
    return Object.assign(Object.assign({}, iconButtonTheme), { defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            size: "medium",
        }, styleOverrides: Object.assign(Object.assign({}, iconButtonTheme.styleOverrides), { root: Object.assign(Object.assign(Object.assign(Object.assign({}, stylesOverridesRoot), button(dt.cta.outlined, ["neutral"], dt)), toggleButton(dt, ["neutral"])), { [`&.${toggleButtonClasses.primary}`]: Object.assign(Object.assign({}, button(dt.cta.outlined, ["primary"], dt)), toggleButton(dt, ["primary"])) }) }) });
};
